// IMPORT LIBS
import jQuery from 'jquery';
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import "regenerator-runtime/runtime";

window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

// IMPORT FUNCTIONS
import { swipersInit } from './functions/sliders';
import { showPartialsFixed } from './functions/partialsFixed';
import { buttonCotationBehavior, buttonFilterBehavior } from './functions/actionsForm';
import { redirectPage } from './functions/redirectPage';
import { handleSetMoreHeight } from './functions/setHeights';
import { controlDate } from './functions/controlDate';


document.addEventListener('DOMContentLoaded', function() {

  setTimeout(() => {
    // FUNCTION TO SET MORE HEIGHT AMONG THE ELEMENTS OF SAME TYPE
    handleSetMoreHeight('.js-pieces-card', 992);
  }, 500);

  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();

  // FUNCTION TO CONTROL HEADER/FOOTER FIXED
  window.addEventListener('scroll', () => {
    showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
    showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
  });

  setInputErrorListener();

  // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
  buttonCotationBehavior('.button-call-form');
  buttonCotationBehavior('.button-product-cotation');
  buttonCotationBehavior('.button-services-cotation');

  // FUNCTION TO CONTROL BEHAVIOR OF FILTERS BUTTONS
  buttonFilterBehavior('.button-call-filter');
  buttonFilterBehavior('.btn-search-fixed-filter');

  // FUNCTION TO REDIRECT TO HOME PAGE
  redirectPage();

  // FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE]
  controlDate('input[type="date"]');




  setLogoWidth(document.querySelector('.header-mobile-actions .logo'));
  setLogoWidth(document.querySelector('.header-top .header-top-logo'));
  setLogoWidth(document.querySelector('.header-fixed-actions .logo'));

  const usedFilterData = document.querySelector('#used-filter-data');

  if(usedFilterData) {
    const dataFilter = usedFilterData.getAttribute('data-filter');
    const filters = JSON.parse(dataFilter);
  }
  
});

// FUNCTION TO ADD OVERLAY ON MODALS
function popUp(selector) {
  $('body,html').addClass('scroll-lock');
  selector.fadeIn('fast');
}

function popClose(form) {
  form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut();
  $('body,html').removeClass('scroll-lock');
}

// FUNCTION TO UP TOP PAGE
$('.btn-scroll-top').on('click', function () {
  $('html,body').animate({ scrollTop: 0 }, '300')
});

// FUNCTION TO PASS INFORMATION TO POP-UP PROMOTIONS
function modalInject(data, target) {
  const { title, img, text } = data;
  $(target).find('.promotion-title').html(title);
  $(target).find('.promotion-img').attr('src', img);
  $(target).find('.promotion-text').html(text);
  popUp($(target));
}

$('.btn-open-modal').on('click', function () {
  const el = $(this).data('target');
  const data = $(this).data('json');
  data ? modalInject(data, el) : popUp($(el));
})

// FUNCTION TO OPEN MODALS
$('.modal-overlay, .btn-close-modal').on('click', function (e) {
  $(e.target).hasClass('form-close') ? popClose() : false
}).on('click', '.pop-up-content', function (event) {
  event.stopPropagation()
});

// FUNCTION TO CONTROL PAGINATIONS
let currentPage = 1;
let currentOrd = 'asc';
let order = 'id';

let isListenerCreated = false;

$('.order-control').on('click', function () {
  if (!isListenerCreated) {
    isListenerCreated = true;
  }

  search(currentPage, isListenerCreated);
});

$('.page-link').on('click', function () {

  currentPage = $(this).data('page');
  $('.page-link').removeClass("active");
  $(this).addClass("active");

  $('.page-item').removeClass("active");
  $(this.parentElement).addClass("active");

  if (currentPage != "1") {
    $('.left-arrow').removeClass("disabled");
    $('.left-arrow').removeClass("active");
  } else {
    $('.left-arrow').addClass("disabled");
  }

  if (!isListenerCreated) {
    isListenerCreated = true;
  }

  search(currentPage, isListenerCreated);
});

function search(pageNum = 1, listenerValue) {
  async function busca() {
    currentOrd = $("#order").val();
    let method = $("#pageId").val();
    let pageLimit = $("#pageLimit").val();

    if(!order){
    order = 'id'
    }

    if(!currentOrd){
    currentOrd = 'asc'
    }

    if(method == 'products'){
      $('#products').css('filter', 'blur(5px)');
      const result = await $.request('onGetProducts', {
      data: {order: order,direction : currentOrd, page: pageNum, limit: pageLimit},
      loading: '.loader-wrapper',
      complete: function(res) {
        $('#products').css('filter', 'unset');
      }
      });
      return result;
    }

      if(method == 'promotions'){
        const result = await $.request('onGetPromotions', {
        data: {order: currentOrd,page: pageNum, limit: pageLimit},
        loading: '.loader-wrapper',
        complete: function(res) {
        }
        });
        return result;
      }

  }

  let a = busca().then( data => $("#products").html(data.result)).finally(
    function () {
      buttonCotationBehavior('.button-product-cotation');

      handleSetMoreHeight('.js-pieces-card', 992);

      if (!listenerValue) {
        $('.page-link').on('click', function () {
          const data = $(this).data('page')
          search(data);
        });
      }
      
    }
  );
}



function setLogoWidth(target) {
  if (target) {
    if (target.naturalWidth > 150) {
      target.classList.add('w-75');
    } else {
      target.classList.remove('w-75');
    }
  }
}

function setInputErrorListener() {
  let inputs = document.querySelectorAll('.form-input');
  let checkboxes = document.querySelectorAll('[type="checkbox"]');

  inputs.forEach((input) => {
    input.addEventListener('focus', () => {
      if (input.classList.contains('alpes-error-input')) {
        input.classList.remove('alpes-error-input');
      }
    })
  });

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('focus', () => {
      if (checkbox.classList.contains('alpes-error-input')) {
        clearCheckBoxError(checkboxes);
      }
    })
  });
  
}

function clearCheckBoxError(target) {
  target.forEach((item) => {
    let checkboxName = item.getAttribute('name');
      item.classList.remove('alpes-error-input');
      document.querySelector(`[for=${checkboxName}]`).classList.remove('alpes-error-input-label');
  })
}